import script from "./MyTravel.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTravel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__